import validator, { DynamicData, ValidationRule } from 'lib/validator';

const ResetPasswordValidator: Array<ValidationRule> = [
  {
    name: 'password',
    rule: (data: DynamicData, name: string): boolean => !!data[name],
    message: 'Please insert login',
  },
  {
    name: 'confirmPassword',
    rule: (data: DynamicData, name: string): boolean => !!data[name],
    message: 'Please insert password',
  },
  {
    name: 'confirmPassword',
    rule: (data: DynamicData, name: string): boolean => data[name] === data['password'],
    message: 'Password mismatch',
  },
];

export default validator(ResetPasswordValidator);
